import styled from 'styled-components';
import { colorUsage, fontWeight } from 'stylesheet';
import { Upload } from 'theme/icons';
import { CTAIconStyle } from '../common/style';
var PublishIcon = styled(Upload).withConfig({
  displayName: "PublishButtonstyle__PublishIcon",
  componentId: "sc-pecavh-0"
})(["", ""], CTAIconStyle);
var ScheduledOn = styled.span.withConfig({
  displayName: "PublishButtonstyle__ScheduledOn",
  componentId: "sc-pecavh-1"
})(["color:", ";font-weight:", ";"], colorUsage.textColorLight, fontWeight.bold);
export { PublishIcon, ScheduledOn };